import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import Tooltip, { ALIGN } from 'gnos-tooltip'
import _ from 'lodash'

import config from '@config'

import { getHighestLevel } from '@global/helpers/helpers'

import { blocksMapToSortedArray } from '../../../../Workspace/helpers'

import {
    LOCALE_PREFIX,
    LISTS,
    PDF_EXPORT_DETAIL_SMALL,
    PDF_EXPORT_DETAIL_BIG,
    PDF_EXPORT_DETAIL_COMPLETE,
    OFU_STANDARD,
} from './constants'

import hocConnect from './hocConnect'
import './style.scss'
import {ENTITY_TYPE} from "../../../../../../../../../global/constants";

@hocConnect
export default class ExportsDesk extends Component {
    static propTypes = {
        activeAccessRightTypes: PropTypes.object,
        activeBlocks: PropTypes.object,
        createPdfExportTask: PropTypes.func.isRequired,
        createXlsExportTask: PropTypes.func.isRequired,
        currentAddressRuianId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        distraintsHistory: PropTypes.object,
        estatesType: PropTypes.string,
        fanalCustomData: PropTypes.object,
        financeTable: PropTypes.object,
        fstmtCustomData: PropTypes.object,
        id: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
        ownershipToggledSections: PropTypes.object,
        paymentComparisonShowChartDataTable: PropTypes.bool,
        privilegesTypeBlocks: PropTypes.object,
        entityType: PropTypes.string,
    }

    getGDPRTooltip() {
        return (
            <>
                <div style={{ fontWeight: 'bold', marginTop: '10px' }}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.tooltip.gdpr.title`} />
                </div>
                <div style={{ marginTop: '10px' }}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.tooltip.gdpr.body`} />
                </div>
                <div style={{ marginTop: '10px' }}>
                    <FormattedMessage
                        id={`${LOCALE_PREFIX}.tooltip.gdpr.links`}
                        values={{
                            acz: (chunks) => (
                                <a
                                    href="https://www.dnb.com/cs-cz/vop"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: '#7fcdee', textDecoration: 'underline' }}
                                >
                                    {chunks}
                                </a>
                            ),
                            ask: (chunks) => (
                                <a
                                    href="https://www.dnb.com/sk-sk/vop"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: '#7fcdee', textDecoration: 'underline' }}
                                >
                                    {chunks}
                                </a>
                            ),
                        }}
                    />
                </div>
            </>
        )
    }

    getExportTooltip(exportDetail) {
        if (exportDetail === PDF_EXPORT_DETAIL_BIG) {
            return (
                <>
                    <div style={{ fontWeight: 'bold' }}>
                        <FormattedMessage id={`${LOCALE_PREFIX}.tooltip.exportDetail.big.title`} />
                    </div>
                    <div style={{ marginTop: '10px' }}>
                        <FormattedMessage
                            id={`${LOCALE_PREFIX}.tooltip.exportDetail.big.body`}
                            values={{ b: (chunks) => <b>{chunks}</b>, br: <br /> }}
                        />
                    </div>
                </>
            )
        }

        if (exportDetail === PDF_EXPORT_DETAIL_COMPLETE) {
            return (
                <>
                    <div style={{ fontWeight: 'bold' }}>
                        <FormattedMessage id={`${LOCALE_PREFIX}.tooltip.exportDetail.complete.title`} />
                    </div>
                    <div style={{ marginTop: '10px' }}>
                        <FormattedMessage
                            id={`${LOCALE_PREFIX}.tooltip.exportDetail.complete.body`}
                            values={{ b: (chunks) => <b>{chunks}</b>, br: <br /> }}
                        />
                    </div>
                </>
            )
        }

        return (
            <>
                <div style={{ fontWeight: 'bold' }}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.tooltip.exportDetail.small.title`} />
                </div>
                <div style={{ marginTop: '10px' }}>
                    <FormattedMessage
                        id={`${LOCALE_PREFIX}.tooltip.exportDetail.small.body`}
                        values={{ b: (chunks) => <b>{chunks}</b>, br: <br /> }}
                    />
                </div>
            </>
        )
    }

    getTooltip(exportDetail) {
        return (
            <>
                {this.getExportTooltip(exportDetail)}
                <div style={{ marginTop: '10px' }}>
                    <FormattedMessage
                        id={`${LOCALE_PREFIX}.tooltip.userSettingsPersistence`}
                        values={{ b: (chunks) => <b>{chunks}</b>, br: <br /> }}
                    />
                </div>
                {this.getGDPRTooltip()}
            </>
        )
    }

    getPdfBlockSettings = (sortedActiveBlocksList) => {
        const {
            addressesActiveAddress,
            alzaScoringCustomData,
            bisnodeScoringCustomData,
            distraintsHistory,
            estatesType,
            fanalCustomData,
            financeTable,
            fstmtLevel,
            fstmtCustomData,
            fanalLevel,
            googleMap,
            ownershipToggledSections,
            paymentComparisonShowChartDataTable,
            paymentIndexCustomData,
            rolesInCompaniesOpenSections,
            velikostCustomData,
        } = this.props

        return sortedActiveBlocksList.reduce((acc, block) => {
            if (block === 'rolesInCompanies' && !!rolesInCompaniesOpenSections) {
                return { ...acc, [block]: { openSections: Object.keys(rolesInCompaniesOpenSections) } }
            }

            if (block === 'addresses') {
                return {
                    ...acc,
                    [block]: {
                        activeZoom: googleMap?.activeAddressZoom,
                        satelliteView: googleMap?.satelliteView,
                        showMap: !googleMap?.collapsed,
                        activeAddress: addressesActiveAddress,
                        ruianId: addressesActiveAddress?.ruianId,
                    },
                }
            }

            if (block === 'alzaScoring') {
                return {
                    ...acc,
                    [block]: {
                        isBankruptcyTableVisible: alzaScoringCustomData?.chartDataTableActive,
                        isTerminologyOpen: alzaScoringCustomData?.isTerminologyOpen,
                    },
                }
            }

            if (block === 'fstmt') {
                const financeTablePojo = financeTable?.toJS()
                return {
                    ...acc,
                    [block]: {
                        level: fstmtLevel,
                        assetsYear: fstmtCustomData?.summary?.assets?.year,
                        liabilitiesYear: fstmtCustomData?.summary?.liabilities?.year,
                        resultsStandard: fstmtCustomData?.results?.currentStandard,
                        cashFlowStandard: fstmtCustomData?.cashFlow?.currentStandard,
                        resultsCompareYear: financeTablePojo?.results?.compareYear,
                        resultsSampleYear: financeTablePojo?.results?.sampleYear,
                        cashFlowCompareYear: financeTablePojo?.cashFlow?.compareYear,
                        cashFlowSampleYear: financeTablePojo?.cashFlow?.sampleYear,
                    },
                }
            }

            if (block === 'fanal') {
                const financeTablePojo = financeTable?.toJS()
                return {
                    ...acc,
                    [block]: {
                        level: fanalLevel,
                        companyCompareYear: financeTablePojo?.analysis?.compareYear,
                        companySampleYear: financeTablePojo?.analysis?.sampleYear,
                        sectorCompareYear: financeTablePojo?.['analysis-sector']?.compareYear,
                        sectorSampleYear: financeTablePojo?.['analysis-sector']?.sampleYear,
                        analyzedYear: fanalCustomData?.radarGraph?.selectedYear,
                    },
                }
            }

            if (block === 'negativeEvents') {
                return {
                    ...acc,
                    [block]: {
                        distraintsHistory,
                    },
                }
            }

            if (block === 'velikost') {
                return {
                    ...acc,
                    [block]: {
                        showProfitTable: velikostCustomData?.showProfitTable,
                        showTurnoverTable: velikostCustomData?.showTurnoverTable,
                        showCapitalTable: velikostCustomData?.showCapitalTable,
                        showEmployeeTable: velikostCustomData?.showEmployeeTable,
                    },
                }
            }

            if (block === 'ownership') {
                return {
                    ...acc,
                    [block]: {
                        ownershipToggledSections,
                    },
                }
            }

            if (block === 'bisnodeScoring') {
                return {
                    ...acc,
                    [block]: {
                        isBankruptcyTableVisible: bisnodeScoringCustomData?.chartDataTableActive,
                        isTerminologyOpen: bisnodeScoringCustomData?.isTerminologyOpen,
                    },
                }
            }

            if (block === 'paymentComparison') {
                return {
                    ...acc,
                    [block]: {
                        showChartDataTable: paymentComparisonShowChartDataTable,
                    },
                }
            }

            if (block === 'paymentIndex') {
                return {
                    ...acc,
                    [block]: {
                        isTerminologyOpen: paymentIndexCustomData?.isTerminologyOpen ?? false,
                        chartDataDataSelector: paymentIndexCustomData?.selector,
                        chartDataTableActive: paymentIndexCustomData?.chartDataTableActive ?? false,
                    },
                }
            }

            if (block === 'estates') {

                return {
                    ...acc,
                    [block]: {
                        type: estatesType,
                        limit: 100,
                    },
                }
            }

            return acc
        }, {})
    }

    canExportPdf() {
        const { activeAccessRightTypes } = this.props
        const activeRightsTypesObject = activeAccessRightTypes?.toJS()

        if (activeRightsTypesObject) {
            return Object.values(activeRightsTypesObject)
                .map((rightType) => rightType?.parameters?.exportPdf)
                .some((exportPdf) => !!exportPdf)
        }

        return false
    }

    handleXlsTaskExport = () => {
        const {
            id,
            module,
            createXlsExportTask,
            activeBlocks,
            currentAddressRuianId,
            fstmtLevel,
            standards,
            cashflow,
            analysisType,
            estatesType,
            entityType,
        } = this.props

        const reportBlocksConfig = _.get(config, 'modules.report.blocks', {})
        let lists = []
        lists = _.reduce(
            reportBlocksConfig,
            (acc, val) => {
                if (activeBlocks.get(val.key)) return [...acc, ..._.get(val, 'export.lists', [])]

                return acc
            },
            []
        )

        if (activeBlocks.get('persons') && entityType === ENTITY_TYPE.NATURAL_PERSON) {
            lists = _.pull(lists, 'statutoryBodies', 'beneficialOwners', 'wayOfNegotiation', 'responsibleRepresentative', 'managers', 'endUserBenefits')
        }


        if (activeBlocks.get('fstmt')) {
            const fstmtHighestLevel = getHighestLevel(fstmtLevel)

            let standardCodes = []
            standardCodes =
                fstmtHighestLevel > 10 ? _.map(standards, (x) => _.get(x, 'statementType', '')) : [OFU_STANDARD]

            // Add cash flow for level 50
            if (fstmtHighestLevel === 50) {
                standardCodes = [...standardCodes, ..._.map(cashflow, (x) => _.get(x, 'statementType', ''))]
            }

            lists = [...lists, ...standardCodes]
        }


        if (activeBlocks.get('fanal') && !_.isNil(analysisType)) {
            lists = [...lists, analysisType]
        }

        if (activeBlocks.get('estates') && estatesType === 'basic' ) {

            lists = _.pull(lists, 'realty-ol','realty-restrictions','realty-estates')
        }

        createXlsExportTask(module, id, {
            body: {
                parameters: {
                    'shared-addresses': {
                        ruianId: currentAddressRuianId,
                    },
                },
            },
            qs: {
                'lists[]': [...lists, LISTS.DISCLAIMER],
            },
        })
    }

    handlePdfTaskExport = (detailLevel) => {
        const { id, module, createPdfExportTask, activeBlocks, privilegesTypeBlocks } = this.props
        const sortedReportBlocks = blocksMapToSortedArray(privilegesTypeBlocks)
        const activeBlocksList = activeBlocks
            .filter((block) => !!block)
            .keySeq()
            .toArray()

        const sortedActiveBlocksList = sortedReportBlocks.filter((reportBlock) =>
            activeBlocksList.includes(reportBlock)
        )

        createPdfExportTask(module, id, {
            body: {
                settings: {
                    viewDetail: detailLevel,
                    blocks: this.getPdfBlockSettings(sortedActiveBlocksList),
                },
            },
            qs: {
                'blocks[]': sortedActiveBlocksList,
            },
        })
    }

    render() {
        const { id } = this.props

        return (
            <div className={'report-exports-desk'}>
                <>
                    <div className={'title'}>
                        <FormattedMessage id={`${LOCALE_PREFIX}.title`} />
                    </div>
                    <div className={'content'}>
                        {this.canExportPdf() && (
                            <>
                                <Tooltip
                                    id={`report-export-pdf-task-basic-tooltip-${id}`}
                                    content={this.getTooltip(PDF_EXPORT_DETAIL_SMALL)}
                                    width={'450px'}
                                    align={ALIGN.END}
                                >
                                    <div
                                        className={'content-row'}
                                        onClick={() => this.handlePdfTaskExport(PDF_EXPORT_DETAIL_SMALL)}
                                    >
                                        <div className={'icon type-pdf'} />
                                        <FormattedMessage id={`${LOCALE_PREFIX}.exportPdfBasic`} />
                                    </div>
                                </Tooltip>
                                <Tooltip
                                    id={`report-export-pdf-task-detailed-tooltip-${id}`}
                                    content={this.getTooltip(PDF_EXPORT_DETAIL_BIG)}
                                    width={'450px'}
                                    align={ALIGN.END}
                                >
                                    <div
                                        className={'content-row'}
                                        onClick={() => this.handlePdfTaskExport(PDF_EXPORT_DETAIL_BIG)}
                                    >
                                        <div className={'icon type-pdf'} />
                                        <FormattedMessage id={`${LOCALE_PREFIX}.exportPdfDetailed`} />
                                    </div>
                                </Tooltip>
                                <Tooltip
                                    id={`report-export-pdf-task-complete-tooltip-${id}`}
                                    content={this.getTooltip(PDF_EXPORT_DETAIL_COMPLETE)}
                                    width={'450px'}
                                    align={ALIGN.END}
                                >
                                    <div
                                        className={'content-row'}
                                        onClick={() => this.handlePdfTaskExport(PDF_EXPORT_DETAIL_COMPLETE)}
                                    >
                                        <div className={'icon type-pdf'} />
                                        <FormattedMessage id={`${LOCALE_PREFIX}.exportPdfComplete`} />
                                    </div>
                                </Tooltip>
                            </>
                        )}
                        <Tooltip
                            id={`report-export-xls-task-tooltip-${id}`}
                            content={this.getGDPRTooltip()}
                            width={'450px'}
                            align={ALIGN.END}
                        >
                            <div className={'content-row'} onClick={() => this.handleXlsTaskExport()}>
                                <div className={'icon type-xls'} />
                                <FormattedMessage id={`${LOCALE_PREFIX}.exportXls`} />
                            </div>
                        </Tooltip>
                    </div>
                </>
            </div>
        )
    }
}
